export default "/_next/static/images/team-bg-b9d2fe22c08e3dfa3442907deaa830ac.png";